// 医生列表表头
export let doctorTableLabels = [
  {
    label: '姓名',
    value: 'name'
  },
  {
    label: '科室',
    value: 'department'
  },
  {
    label: '执业医院数量（个）',
    value: 'hospitalNum'
  },
  {
    label: '身份证号',
    value: 'idCard'
  },
  {
    label: '手机号',
    minWidth: 120,
    value: 'mobile'
  },
  {
    label: '分/子公司',
    value: 'branchCompanyName'
  },
  {
    label: '所属省份',
    value: 'provinceName'
  },
  {
    label: '所属市',
    value: 'cityName'
  },
  {
    label: '创建时间',
    minWidth: 110,
    value: 'create_date'
  }
]
// 医院列表表头
export let HospitalTableLabels = [
  {
    label: '医院名称',
    value: 'name'
  },
  {
    label: '分/子公司',
    value: 'branchName'
  },
  {
    label: '地区',
    value: 'address'
  },
  {
    label: '医院地址',
    value: 'hospitalAddress'
  },
  {
    label: '联系人',
    value: 'contractor'
  },
  {
    label: '手机号',
    value: 'mobile'
  }
]
export let errDoctorLabels = [
  {
    label: '姓名',
    value: 'data.name'
  },
  {
    label: '手机号',
    value: 'data.mobile'
  },
  {
    label: '所属省',
    value: 'data.province'
  },
  {
    label: '所属市',
    value: 'data.city'
  },
  {
    label: '错误原因',
    value: 'details'
  }
]
// 选择医生的列表表头
export let doctorDialogLabels = [
  {
    label: '医院名称',
    value: 'name'
  },
  {
    label: '分/子公司',
    value: 'branchName'
  },
  {
    label: '地区',
    value: 'address'
  }
]
// 选择医院的筛选表头
export let doctorSelectTable = [{
  label: '分/子公司',
  type: 'select',
  value: 'branchId',
  clearable: true,
  filterable: true,
  options: []
}]
// 医院列表的筛选表头
export let HospitalTable = [ {
  label: '分/子公司',
  type: 'select',
  value: 'branchId',
  clearable: true,
  options: []
}]
// 医生筛选条件
export let doctorFilterLabels = [
  {
    label: '创建时间',
    type: 'time-slot',
    startName: 'start', // 返回数据时，开始时间的字段名
    endName: 'end', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  },
  {
    label: '医生所属省市',
    type: 'address-select',
    value: 'proviveAndCity',
    clearable: true,
    addressShowElement: {
      province: true,
      city: true
    }
  }
]
export let doctorTabs = [
  {
    label: '全部医生',
    value: 'ALL'
  },
  {
    label: '产科问答医生',
    value: 'obs'
  }
]
// 产科问答是否开启radios
export let questionRadios = [
  {
    label: '是',
    value: 'true'
  },
  {
    label: '否',
    value: 'false'
  }
]
